module.exports = __webpack_public_path__ + "img/batches.9cf2bcc0.svg";